import api from 'api'

type TransitionToNextTierRequest = {
  listingId: number
}

export const transitionToNextTier = async (
  request: TransitionToNextTierRequest
) => {
  const response = await api.post<void>(
    `/admin/listing/${request.listingId}/next`
  )
  return response.data
}
